module.exports = __webpack_public_path__ + "img/UTOTTE-1.e15c46fa.jpg";